




















































import Vue from "vue";
import moment from "moment/moment";
import $store from "@/store/store";
import Component, { mixins } from "vue-class-component";
import CoffreMixin from "@/mixins/coffreUtils";
import ErrorMixin from "@/mixins/errorMixins";

@Component({
  components: {},
})
export default class ListExports extends mixins(CoffreMixin, ErrorMixin) {
  public datePick: any = new Date().toISOString().substr(0, 10);
  public recus = new Array();
  public loadData = false;
  public search = "";
  public headers = [
    {
      text: this.$t("Date.fiscale"),
      value: "dateFiscaleExport",
      class: "data-head",
    },
    { text: this.$t("Date.etheure"), value: "horodatage", class: "data-head" },
    { text: "ID restaurant", value: "restaurantId", class: "data-head" },
    { text: this.$t("Site"), value: "libSite", class: "data-head" },
    { text: this.$t("typeExport"), value: "export", class: "data-head" },
  ];

  public getRecus() {
    this.loadData = true;
    this.$store.dispatch("analyses/getExports", this.datePick).then(
      (response: any) => {
        this.recus = response;
        this.loadData = false;
      },
      (error: any) => {
        console.log(error);
        this.setErrorFromTxt(error.toString());
        this.loadData = false;
        // this.$store.dispatch("login/setLoading", false);
      }
    );
  }

  public formatDateTicket(horodatage: number) {
    const d = moment(horodatage).format("DD/MM/YYYY");
    return d;
  }

  public formatExport(complements: any) {
    const monexport = complements.find(
      (cmpl: any) => cmpl.cle === "natureExport"
    );
    if (monexport) {
      return monexport.valeur;
    } else {
      return "";
    }
  }

  public formatDateTicketExport(complements: any) {
    const monexport = complements.find(
      (cmpl: any) => cmpl.cle === "dateFiscaleExport"
    );
    const d = moment(monexport).format("DD/MM/YYYY");
    return d;
  }
}
